import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import {
  useVesselContext,
  vesselDialogs,
} from '../../../Contexts/Modules/SampleModule/VesselModule'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useQueryClient } from 'react-query'
import { LoadingButton } from '@mui/lab'
import { useStuartMutate } from '../../../APIs/Hooks/PhpAPIHooks'

function MoveConfirmDialog() {
  const { loginConfig } = useUserContext()
  const { setMessage } = useMessagePopupContext()
  const { vesselQuery, fields, openDialog, setOpenDialog } = useVesselContext()
  const { data: vessel } = vesselQuery
  const queryClient = useQueryClient()
  const { mutate: change, isLoading } = useStuartMutate(
    `/vessel/changeVesselHolding.php?ToHoldingID=${fields?.holdingID}&VesselID=${vesselQuery.data?.VesselID}`,
    async (data) => {
      if (data?.Success) {
        setOpenDialog(undefined)
        await queryClient.invalidateQueries({
          queryKey: ['PhpAPI', '/stuart', '/vessel/getVessel.php'],
        })
      } else {
        setMessage({
          subject: 'Error',
          severity: 'warning',
          message:
            data?.message ??
            'An unexpected error occurred changing the vessel holding',
        })
      }
    },
  )
  return (
    <Dialog
      open={openDialog === vesselDialogs.MOVE_CONFIRM}
      onClose={() => setOpenDialog(undefined)}
    >
      <DialogTitle>{'Change Vessel Holding'}</DialogTitle>
      <DialogContent>
        Move Vessel {vessel?.VesselID} from holding{' '}
        {getCodeSetLabelLookup(loginConfig, ['KV-Holdings'], vessel?.HoldingID)}{' '}
        to holding{' '}
        {getCodeSetLabelLookup(loginConfig, ['KV-Holdings'], fields?.holdingID)}
        ?
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpenDialog(undefined)}
          color="error"
          disabled={isLoading}
        >
          Cancel
        </Button>
        <LoadingButton
          onClick={() => change()}
          loading={isLoading}
          color="success"
        >
          Change Holding
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default MoveConfirmDialog
